import {
  IProfileData,
  ProfilePrivileges,
  PROFILE_ACTIONS,
} from '../interfaces/profileData';
import { getProfileData } from '../services/dashboard';

export const getDataWithCheckingActionPrivilege = <T>(
  shouldCheckPrivilege: boolean,
  serviceId: string,
  action: PROFILE_ACTIONS,
  callback: () => Promise<T>
): Promise<T> => {
  if (!shouldCheckPrivilege) {
    return callback();
  }

  return checkActionPrivilege(serviceId, action).then(() => {
    return callback();
  });
};

export const checkActionPrivilege = (
  serviceId: string,
  action: PROFILE_ACTIONS
): Promise<void> => {
  return getProfileData(serviceId)
    .then((profileData: IProfileData) => profileData.priviledges)
    .then((privileges: ProfilePrivileges) => {
      if (privileges[action] === 'true') {
        return Promise.resolve();
      }

      throw new Error(
        `This account does not have privilege to "${action
          .toLowerCase()
          .replace('_', ' ')}".`
      );
    });
};
